import { render } from "./AllSpecialities.vue?vue&type=template&id=6b44e040&scoped=true"
import script from "./AllSpecialities.vue?vue&type=script&lang=js"
export * from "./AllSpecialities.vue?vue&type=script&lang=js"

import "./AllSpecialities.vue?vue&type=style&index=0&id=6b44e040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b44e040"]])

export default __exports__